module.exports = __webpack_public_path__ + "img/27.af73be2b.jpg";